import * as Ariakit from '@ariakit/react';
import styled from 'styled-components';
import { easeInOutCubic, fromMd, timingFast, untilMd, zIndexModal } from '../../../constants';
export const InheritedRadius = styled.div(o => {
    if (o.$dir === 'top') {
        return {
            borderTopRightRadius: 'inherit',
            borderTopLeftRadius: 'inherit',
            overflow: 'hidden',
        };
    }
    if (o.$dir === 'bottom') {
        return {
            borderBottomRightRadius: 'inherit',
            borderBottomLeftRadius: 'inherit',
            overflow: 'hidden',
        };
    }
    return {};
});
export const DialogContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0px;
  z-index: ${zIndexModal};
  overflow: auto;
  padding: ${o => (o.$fullscreenMobile ? 0 : o.theme.spacing(16, 4))};

  ${fromMd} {
    padding: ${o => o.theme.spacing(16, 4)};
  }
`;
export const Modal = styled(Ariakit.Dialog) `
  background-color: ${o => o.theme.color.fill.background};
  border-radius: 3px;
  position: relative;
  z-index: ${zIndexModal};
  margin: auto;
  min-width: 80vw;
  max-width: 100%;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  transform: scale(0.975);
  opacity: 0;
  transition:
    ${timingFast} ${easeInOutCubic} transform,
    ${timingFast} ${easeInOutCubic} opacity;

  ${untilMd} {
    ${o => o.$fullscreenMobile &&
    `
    width: 100vw;
    border-radius: 0;
  `}
  }

  ${fromMd} {
    min-width: 400px;
    max-width: 50vw;
  }

  &[data-enter] {
    transform: scale(1);
    opacity: 1;
  }
`;
//# sourceMappingURL=styles.js.map